export const environment = {
  production: true,
  url: "https://specyfikator.autocuby.eu",
  whitelistedDomains: [
    "http://specyfikator.autocuby.eu/",
    "specyfikator.autocuby.eu/",
    "specyfikator.autocuby.eu",
    "https://specyfikator.autocuby.eu",
  ],
  specificatorLanguage: "specificatorLanguage",
  specificatorViewOrderEquipmentCosts: "specificatorViewOrderEquipmentCosts",
  hardenedDocumentEmailConfirmation: [
    "patrycja.k@autocuby.pl",
    "jarek.p@autocuby.pl",
  ],
  plnToEuroExchangeRate: 4.6,
  orderColumnSettings: "orderColumnSettings",
  logrocketAppId: "akovzu/specyfikator-prod",
  tinyMceApiKey: "xycnqk8df8zf3pds3y7ej1u91ubiczy5xligf05ixkdz585v",
};
